<section class="page">
  <header class="page-header">
    <button mat-icon-button type="button" (click)="goBack()"><mat-icon>arrow_back</mat-icon></button>
    <div>
      <h1>{{ bug()?.title || 'Bug detail' }}</h1>
      <p class="muted">{{ bug()?.description || '—' }}</p>
    </div>
  </header>

  @if (error()) { <div class="error">{{ error() }}</div> }
  @if (loading()) { <div class="loading"><mat-spinner diameter="36"></mat-spinner></div> }

  @if (!loading() && bug(); as b) {
    <mat-card class="panel">
      <mat-card-content>
        <div class="meta">
          <span>Severity: {{ label(severityOptions, b.severity) }}</span>
          <span>Category: {{ label(categoryOptions, b.category) }}</span>
          <span>Created: {{ b.createdAt || '—' }}</span>
        </div>
        @if (b.stepsToReproduce) {
          <h3>Steps to reproduce</h3>
          <p>{{ b.stepsToReproduce }}</p>
        }
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select [(ngModel)]="editStatus">
              @for (s of statusOptions; track s.value) {
                <mat-option [value]="s.value">{{ s.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button mat-stroked-button type="button" (click)="saveStatus()">Update status</button>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="panel">
      <mat-card-header><mat-card-title>Comments</mat-card-title></mat-card-header>
      <mat-card-content>
        @for (c of comments(); track c.id) {
          <div class="comment">
            <span class="muted">{{ c.createdAt | date:'medium' }}</span>
            <p>{{ c.content }}</p>
          </div>
        } @empty { <p class="muted">No comments yet.</p> }
        <mat-form-field appearance="outline" class="full">
          <mat-label>Add comment</mat-label>
          <textarea matInput rows="2" [(ngModel)]="newComment"></textarea>
        </mat-form-field>
        <button mat-flat-button color="primary" [disabled]="saving() || !newComment.trim()" (click)="addComment()">Post</button>
      </mat-card-content>
    </mat-card>
  }
</section>
